module.exports = __webpack_public_path__ + "img/handle.6cb49a78.svg";